import React from "react";
import { TwitterTimelineEmbed } from "react-twitter-embed";
import { NavLink } from "react-router-dom";
const Twittie = () => {
  return (
    <section className="twittie">
      <div
        className="page-wrap twitter-feeds-wrapper"
        style={{ backgroundSize: "cover", height: "600px" }}
      >
        <div className="row section-header" style={{ position: "initial" }}>
          <h3 className="section-heading fadeIn" style={{ color: "#666" }}>
            Virtuos Tweets
          </h3>
          <NavLink
            to="https://twitter.com/virtuos"
            target="_blank"
            rel="nofollow"
            className="btn btn-twitter"
          >
            <i className="fab fa-twitter"></i> Follow @virtuos
          </NavLink>
        </div>
        <div className="tweet" style={{ height: "100%" }}>
          {/* <Timeline
            dataSource={{
              sourceType: "url",
              url: "https://twitter.com/virtuos",
            }}
            options={{
              height: "400",
             
            }}
          /> */}
          <TwitterTimelineEmbed
            sourceType="profile"
            screenName="virtuos"
            options={{
              tweetLimit: 5,
              height: 400,
              chrome: 'nofooter noborder noscrollbar noheader transparent'
            }}
          />
        </div>
       
        {/* <a
          className="twitter-timeline"
          href="https://twitter.com/virtuos"
          data-tweet-limit="3"
        >
          Tweets by @TwitterDev
        </a> */}
        <div
          className="twitter-man wow fadeInRight duration animated"
          data-wow-duration="1000ms"
          data-wow-delay="800ms"
        >
          <img
            src={`/img/svg/twitter-man.svg`}
            alt="Twitter Man"
          />
        </div>

      </div>
      <p className=""style={{textAlign:"center",fontWeight:"600", color:"#666e99"}}>*Please click on View on Twitter button and then login to see tweets.</p>
    </section>
  );
};

export default Twittie;
